export enum DownloadContentType {
    Excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    JSON = 'application/json',
    Image = 'image/jpeg'
}

class CoreDownloadService {
    public downloadFileCore(file: Blob | string | object, fileName: string, contentType: DownloadContentType) {
        if (!(file instanceof Blob) && typeof file === 'object') {
            file = JSON.stringify(file, null, '  ');
        }

        const downloadLink = window.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([file], { type: contentType }));
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        window.URL.revokeObjectURL(downloadLink.href);
        document.body.removeChild(downloadLink);
    }

    public downloadImageCore(fileUrl: string, fileName: string) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', fileUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function() {
            if (window.navigator.msSaveOrOpenBlob) { // IE11
                const blob = new Blob([this.response], {
                    type: DownloadContentType.Image
                });

                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                const urlCreator = window.URL || window.webkitURL;
                const imageUrl = urlCreator.createObjectURL(this.response);
                const tag = document.createElement('a');
                tag.href = imageUrl;
                tag.download = fileName;
                document.body.appendChild(tag);
                tag.click();
                document.body.removeChild(tag);
            }
        };
        xhr.send();
    }
}

export default new CoreDownloadService();
